import { formatTimestampHuman } from "../date-utils";
export const portalUserDtoFields = [{
        name: "email",
        title: "E-mail"
    }, {
        name: "lastName",
        title: "Cognome"
    }, {
        name: "firstName",
        title: "Nome"
    }, {
        name: "portalRoleCode",
        title: "Ruolo",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered"
    }, {
        name: "phoneExtension",
        title: "Interno",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered"
    }, {
        name: "active",
        title: "Abilitato",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.active === 1 ? "check" : "close"}</i>`
    }, {
        name: "lastLoginOn",
        title: "Ultimo Accesso",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatTimestampHuman(record.lastLoginOn)
    }];
